<!-- ══════════════════════════════════════════════════
     LOADING OVERLAY
══════════════════════════════════════════════════ -->
<div class="loading-overlay" *ngIf="cargando" aria-live="polite" aria-busy="true">
    <div class="loading-content" role="status">
        <div class="loader-ellipsis" aria-hidden="true">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div class="loading-title" aria-hidden="true">Cargando información</div>
        <span class="sr-only">Cargando…</span>
    </div>
</div>

<!-- ── Carga inicial ── -->
<div *ngIf="!adeudo" class="cargando-inicial container py-3">
    <div class="progress progress-institucional">
        <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width: 100%">
        </div>
    </div>
    <p class="cargando-texto text-right mt-1">Cargando información...</p>
</div>

<!-- ══════════════════════════════════════════════════
     CONTENIDO PRINCIPAL
══════════════════════════════════════════════════ -->
<div *ngIf="adeudo" class="adeudo-page">

    <!-- ── Encabezado de página ── -->
    <div class="pagina-header">
        <div class="container contenedor-amplio">
            <button class="pagina-header__volver" (click)="Regresar()" [disabled]="recalculando">
                <i class="fa-solid fa-arrow-left" aria-hidden="true"></i> Consultar otra clave
            </button>
            <div class="pagina-header__fila">
                <div>
                    <p class="pagina-header__kicker">Impuesto predial · Estado de cuenta</p>
                    <h1 class="pagina-header__titulo">Información del predio</h1>
                </div>
                <div class="pagina-header__clave">
                    <span>Clave catastral</span>
                    <strong>{{cve_cast}}</strong>
                </div>
            </div>
        </div>
    </div>

    <!-- ══════════════════════════════════════════════
         DATOS DEL CONTRIBUYENTE Y PREDIO
    ═══════════════════════════════════════════════ -->
    <div class="container contenedor-amplio mb-4">
        <div class="row">

            <!-- Tarjeta contribuyente -->
            <div class="col-md-4 mb-4 mb-md-0">
                <div class="contribuyente-card" id="contribuyente">
                    <div class="contribuyente-card__top">
                        <i class="fas fa-user-circle" id="icono"></i>
                        <div class="contribuyente-card__nombre-wrap">
                            <p class="contribuyente-card__label">Propietario</p>
                            <h5 class="contribuyente-card__nombre">{{adeudo.Nombre_Propietario}}</h5>
                        </div>
                    </div>
                    <div class="contribuyente-card__badge">
                        <i class="fas fa-map-pin mr-1"></i>{{cve_cast}}
                    </div>
                    <div class="contribuyente-card__details">
                        <div class="contribuyente-detail">
                            <span class="contribuyente-detail__label">RFC</span>
                            <span class="contribuyente-detail__value">{{adeudo.RFC == 0 ? 'No registrado' :
                                adeudo.RFC}}</span>
                        </div>
                        <div class="contribuyente-detail">
                            <span class="contribuyente-detail__label">Domicilio fiscal</span>
                            <span class="contribuyente-detail__value">{{adeudo.Ubicacion_Propiedad}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Datos de ubicación -->
            <div class="col-md-4 mb-4 mb-md-0">
                <div class="data-card">
                    <div class="data-card__title">
                        <i class="fas fa-map-marker-alt"></i>Ubicación del Predio
                    </div>
                    <div class="data-list">
                        <div class="data-row">
                            <span class="data-row__label">Domicilio</span>
                            <span class="data-row__value">{{adeudo.Domicilio_Propiedad}}</span>
                        </div>
                        <div class="data-row">
                            <span class="data-row__label">Colonia</span>
                            <span class="data-row__value">{{adeudo.Colonia_Propiedad}}</span>
                        </div>
                        <div class="data-row">
                            <span class="data-row__label">Población</span>
                            <span class="data-row__value">{{adeudo.Poblacion_Propiedad}}</span>
                        </div>
                        <div class="data-row">
                            <span class="data-row__label">Municipio</span>
                            <span class="data-row__value">{{municipio}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Datos catastrales -->
            <div class="col-md-4">
                <div class="data-card">
                    <div class="data-card__title">
                        <i class="fas fa-file-alt"></i>Datos Catastrales
                    </div>
                    <div class="data-list">
                        <div class="data-row">
                            <span class="data-row__label">Valor catastral</span>
                            <span class="data-row__value data-row__value--highlight">
                                {{adeudo.Valor_Catastral | currency}}
                            </span>
                        </div>
                        <div class="data-row">
                            <span class="data-row__label">Sup. terreno</span>
                            <span class="data-row__value">{{adeudo.Superficie_Terreno | number: '1.2-2'}} m²</span>
                        </div>
                        <div class="data-row">
                            <span class="data-row__label">Sup. construcción</span>
                            <span class="data-row__value">{{adeudo.Superficie_Construccion | number: '1.2-2'}} m²</span>
                        </div>
                        <div class="data-row">
                            <span class="data-row__label">Subsidio</span>
                            <span class="data-row__value">{{adeudo.Tipo_Subsidio}}</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <!-- ── Estados especiales ── -->
    <div *ngIf="this.adeudo.Cve_Catastral == null" class="container mb-4">
        <div class="estado-mensaje estado-mensaje--warning">
            <i class="fas fa-exclamation-triangle"></i>
            <span>No existe esta clave catastral.</span>
        </div>
    </div>

    <div *ngIf="adeudo.Total == 0 && this.adeudo.Cve_Catastral != null && (adeudo.StatusPredio == 'ACTIVO' || adeudo.StatusPredio == 'SIN DEMANDA')"
        class="container mb-4">
        <div class="estado-mensaje estado-mensaje--success">
            <i class="fas fa-check-circle"></i>
            <span>La clave catastral no presenta adeudo. ¡Estás al corriente!</span>
        </div>
    </div>

    <div *ngIf="adeudo.StatusPredio == 'DEMANDA'" class="container mb-4">
        <div class="estado-mensaje estado-mensaje--error">
            <i class="fas fa-ban"></i>
            <span>La clave catastral no se puede pagar en línea.</span>
        </div>
    </div>

    <!-- ══════════════════════════════════════════════
         ADEUDO: PERIODOS + RESUMEN DE PAGO
    ═══════════════════════════════════════════════ -->
    <div *ngIf="adeudo.Total != 0" class="container contenedor-amplio pb-5">
        <div class="adeudo-layout">

            <!-- ── Periodos ── -->
            <div class="adeudo-layout__principal">
                <section class="periodos-card">
                    <header class="periodos-card__header">
                        <div>
                            <h2 class="periodos-card__titulo">Periodos con adeudo</h2>
                            <p class="periodos-card__ayuda">
                                Puede pagar hasta el periodo que elija. Los periodos se liquidan en orden, del más antiguo al más reciente.
                            </p>
                        </div>
                        <span class="periodos-card__contador">
                            <strong>{{ periodosSeleccionados }}</strong> de {{ adeudo.Detalle?.length }} seleccionados
                        </span>
                    </header>

                    <div *ngIf="recalculando" class="periodos-card__recalculo">
                        <div class="progress progress-institucional">
                            <div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style="width: 100%"></div>
                        </div>
                        <span>Recalculando importes…</span>
                    </div>

                    <!-- Desktop -->
                    <div class="tabla-wrapper d-none d-md-block">
                        <table class="table tabla-adeudo mb-0">
                            <thead>
                                <tr>
                                    <th scope="col">Periodo</th>
                                    <th scope="col" class="text-right">Principal</th>
                                    <th scope="col" class="text-right">A.C.O</th>
                                    <th scope="col" class="text-right">Asist. social</th>
                                    <th scope="col" class="text-right">Subsidio</th>
                                    <th scope="col" class="text-right">Pronto pago</th>
                                    <th scope="col" class="text-right">Recargo</th>
                                    <th scope="col" class="text-right">Multa</th>
                                    <th scope="col" class="text-right">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let detalle of this.adeudo.Detalle; let indice=index;"
                                    [ngClass]="{'row-deshabilitado': !detalle.check && indice != 0, 'row-seleccionado': detalle.check || indice == 0}">
                                    <td>
                                        <div class="periodo-check">
                                            <input [disabled]="indice==0 || recalculando"
                                                (click)="CambioCheck(detalle.check, indice)" type="checkbox"
                                                [(ngModel)]="detalle.check" class="form-check-input"
                                                id="{{ detalle.anio }}-{{ detalle.trimestre }}">
                                            <label for="{{ detalle.anio }}-{{ detalle.trimestre }}">
                                                {{ detalle.anio }} <span class="periodo-trim">T{{detalle.trimestre}}</span>
                                            </label>
                                            <span *ngIf="indice == 0" class="periodo-obligatorio" title="El periodo más antiguo siempre se incluye">
                                                <i class="fa-solid fa-lock" aria-hidden="true"></i>
                                            </span>
                                        </div>
                                    </td>
                                    <td class="text-right">{{ detalle.principal | currency }}</td>
                                    <td class="text-right">{{ detalle.actualizacion | currency }}</td>
                                    <td class="text-right">{{ detalle.asistencia_social | currency }}</td>
                                    <td class="text-right">{{ detalle.descuento | currency }}</td>
                                    <td class="text-right">{{ detalle.prontopago | currency }}</td>
                                    <td class="text-right">{{ detalle.recargos | currency }}</td>
                                    <td class="text-right">{{ detalle.multas | currency }}</td>
                                    <td class="text-right tabla-adeudo__total-cell">{{ detalle.total | currency }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Móvil -->
                    <div class="d-block d-md-none periodos-movil">
                        <div *ngFor="let detalle of this.adeudo.Detalle; let indice=index;" class="periodo-item"
                            [ngClass]="{'periodo-item--off': !detalle.check && indice != 0}">
                            <div class="periodo-item__fila">
                                <div class="periodo-check">
                                    <input [disabled]="indice==0 || recalculando" (click)="CambioCheck(detalle.check, indice)" type="checkbox"
                                        [(ngModel)]="detalle.check" class="form-check-input"
                                        id="{{ detalle.anio }}-mob-{{ detalle.trimestre }}">
                                    <label class="m-0" for="{{ detalle.anio }}-mob-{{ detalle.trimestre }}">
                                        {{ detalle.anio }} <span class="periodo-trim">T{{ detalle.trimestre }}</span>
                                    </label>
                                    <span *ngIf="indice == 0" class="periodo-obligatorio"><i class="fa-solid fa-lock" aria-hidden="true"></i></span>
                                </div>
                                <button type="button" class="periodo-item__toggle" (click)="ToggleDesglose(indice)"
                                    [attr.aria-expanded]="!!desglose_abierto[indice]"
                                    [attr.aria-controls]="'desglose-' + indice">
                                    Desglose <i class="fa-solid" [ngClass]="desglose_abierto[indice] ? 'fa-chevron-up' : 'fa-chevron-down'" aria-hidden="true"></i>
                                </button>
                                <strong class="periodo-item__total">{{ detalle.total | currency }}</strong>
                            </div>
                            <dl class="periodo-item__detalle" *ngIf="desglose_abierto[indice]" [id]="'desglose-' + indice">
                                <div><dt>Principal</dt><dd>{{ detalle.principal | currency }}</dd></div>
                                <div><dt>A.C.O</dt><dd>{{ detalle.actualizacion | currency }}</dd></div>
                                <div><dt>Asistencia social</dt><dd>{{ detalle.asistencia_social | currency }}</dd></div>
                                <div><dt>Subsidio</dt><dd>{{ detalle.descuento | currency }}</dd></div>
                                <div><dt>Pronto pago</dt><dd>{{ detalle.prontopago | currency }}</dd></div>
                                <div><dt>Recargo</dt><dd>{{ detalle.recargos | currency }}</dd></div>
                                <div><dt>Multa</dt><dd>{{ detalle.multas | currency }}</dd></div>
                            </dl>
                        </div>
                    </div>
                </section>
            </div>

            <!-- ── Resumen y pago ── -->
            <div class="adeudo-layout__resumen">
                <aside class="resumen-pago">
                    <div class="resumen-pago__encabezado">
                        <span class="resumen-pago__label">Total a pagar</span>
                        <span class="resumen-pago__total">{{ this.adeudo.Total | currency }}</span>
                        <span class="resumen-pago__periodo" *ngIf="periodoHasta">
                            Periodos {{ adeudo.Detalle[0]?.anio }} T{{ adeudo.Detalle[0]?.trimestre }} a {{ periodoHasta }}
                        </span>
                    </div>

                    <div class="resumen-pago__conceptos">
                        <div class="resumen-fila">
                            <span>Honorarios de notificación</span>
                            <strong>{{this.adeudo.Honorarios_Notificacion | currency}}</strong>
                        </div>
                        <div class="resumen-fila">
                            <span>Gastos extraordinarios de cobranza</span>
                            <strong>{{this.adeudo.GastosExtCobranza | currency}}</strong>
                        </div>
                        <div class="resumen-fila" [hidden]="!descuento_insen">
                            <span>INAPAM</span>
                            <strong>{{this.adeudo.insen | currency}}</strong>
                        </div>
                        <div class="resumen-fila" [hidden]="!cobro_cruzroja">
                            <span>Cruz Roja</span>
                            <strong>{{this.adeudo.ImporteCruzRoja | currency}}</strong>
                        </div>
                        <div class="resumen-fila" [hidden]="!cobro_bomberos">
                            <span>Bomberos</span>
                            <strong>{{this.adeudo.ImporteBomberos | currency}}</strong>
                        </div>
                        <div class="resumen-fila">
                            <span>Redondeo</span>
                            <strong>{{this.adeudo.Redondeo | currency}}</strong>
                        </div>
                    </div>

                    <div class="resumen-pago__acciones pago-opciones__grid">

                        <!-- BBVA -->
                        <div class="pago-opcion" *ngIf="environment_.bbva">
                            <form #formulario action="https://www.adquiramexico.com.mx:443/mExpress/pago/avanzado"
                                method="POST">
                                <input type="hidden" name="importe" value="{{this.adeudo.Total}}" />
                                <input type="hidden" name="referencia" value="{{this.referencia_pago}}" />
                                <input type="hidden" name="urlretorno" value="{{url_api}}PagosPredial/PostAcreditacionPago" />
                                <input type="hidden" name="idexpress" value="{{id_express}}" />
                                <input type="hidden" name="financiamiento" value="0" />
                                <input type="hidden" name="plazos" value="" />
                                <input type="hidden" name="mediospago" value="100000" />
                                <input type="hidden" name="signature" value="{{this.generated_signature}}" />
                                <button (click)="ValidarSubmit()" class="btn-pago"
                                    [disabled]="recalculando || adeudo.Total == 0">
                                    <i class="fa-solid fa-lock"></i>
                                    <span>Pagar {{ this.adeudo.Total | currency }}</span>
                                </button>
                            </form>
                        </div>

                        <!-- BBVA Rosario -->
                        <div class="pago-opcion" *ngIf="environment_.bbva_rosario">
                            <form #formulario action="https://www.adquiramexico.com.mx:443/mExpress/pago/avanzado"
                                method="POST">
                                <input type="hidden" name="importe" value="{{this.adeudo.Total}}" />
                                <input type="hidden" name="referencia" value="{{this.referencia_pago}}" />
                                <input type="hidden" name="urlretorno"
                                    value="https://api.pagoselrosario.com.mx/api/PagosPredial/PostAcreditacionPago" />
                                <input type="hidden" name="idexpress" value="{{id_express}}" />
                                <input type="hidden" name="financiamiento" value="0" />
                                <input type="hidden" name="plazos" value="" />
                                <input type="hidden" name="mediospago" value="100000" />
                                <input type="hidden" name="signature" value="{{this.generated_signature}}" />
                                <button (click)="ValidarSubmitRosario()" class="btn-pago"
                                    [disabled]="recalculando || adeudo.Total == 0">
                                    <i class="fa-solid fa-lock"></i>
                                    <span>Pagar con BBVA</span>
                                </button>
                            </form>
                        </div>

                        <!-- BanBajío -->
                        <div class="pago-opcion" *ngIf="environment_.bajio">
                            <form #formulariobajio enctype="multipart/form-data">
                                <input [hidden]="true" type="text" name="servicio" value="9765365">
                                <input [hidden]="true" type="text" name="concepto" value="01">
                                <input [hidden]="true" type="text" name="folio" value="01">
                                <input [hidden]="true" type="text" name="referencia" value="{{this.referencia_pago}}">
                                <input [hidden]="true" type="number" name="monto" step="0.1" value="{{this.adeudo.Total}}">
                                <button (click)="ValidarBajio()" class="btn-pago btn-pago--bajio"
                                    [disabled]="recalculando || adeudo.Total == 0">
                                    <i class="fa-solid fa-lock"></i>
                                    <span>Pagar con BanBajío</span>
                                </button>
                            </form>
                        </div>

                        <!-- Azteca -->
                        <div class="pago-opcion" *ngIf="environment_.azteca">
                            <form #formulariobajio enctype="multipart/form-data">
                                <button (click)="ValidarAzteca()" class="btn-pago btn-pago--azteca"
                                    [disabled]="recalculando || adeudo.Total == 0">
                                    <i class="fa-solid fa-lock"></i>
                                    <span>Pagar {{ this.adeudo.Total | currency }}</span>
                                </button>
                            </form>
                        </div>

                    </div>

                    <div class="resumen-pago__confianza" *ngIf="!environment_.banorte">
                        <div class="confianza-tarjetas" aria-label="Tarjetas aceptadas">
                            <i class="fa-brands fa-cc-visa" aria-hidden="true"></i>
                            <i class="fa-brands fa-cc-mastercard" aria-hidden="true"></i>
                            <span>Crédito y débito</span>
                        </div>
                        <p>
                            <i class="fa-solid fa-shield-halved" aria-hidden="true"></i>
                            Pago seguro con autenticación 3-D Secure. Será dirigido al portal del banco para capturar su tarjeta; el municipio no almacena sus datos.
                        </p>
                    </div>
                </aside>
            </div>

        </div>
    </div>

    <!-- ══════════════════════════════════════════════
         FORMULARIO BANORTE
    ═══════════════════════════════════════════════ -->
    <div class="container pb-5" *ngIf="environment_.banorte">
        <div class="banorte-card">
            <div class="banorte-card__header">
                <i class="far fa-credit-card mr-2"></i>Pago con Tarjeta &mdash; Banorte
            </div>
            <div class="banorte-card__body">

                <!-- Hidden form fields -->
                <form method="POST" #formulariobanorte action="https://via.banorte.com/secure3d/Solucion3DSecure.htm">
                    <input type="hidden" name="NUMERO_TARJETA" value="{{this.prepago_banorte.numero_tarjeta}}" />
                    <input type="hidden" name="FECHA_EXP" value="{{this.prepago_banorte.fecha_exp}}" />
                    <input type="hidden" name="MONTO" value="{{this.prepago_banorte.monto}}" />
                    <input type="hidden" name="MARCA_TARJETA" value="{{this.prepago_banorte.marca_tarjeta}}" />
                    <input type="hidden" name="ID_AFILIACION" value="{{this.prepago_banorte.id_afiliacion}}" />
                    <input type="hidden" name="NOMBRE_COMERCIO" value="{{this.prepago_banorte.nombre_comercio}}" />
                    <input type="hidden" name="CIUDAD_COMERCIO" value="{{this.prepago_banorte.ciudad_comercio}}" />
                    <input type="hidden" name="URL_RESPUESTA" value="{{this.prepago_banorte.url_respuesta}}" />
                    <input type="hidden" name="CERTIFICACION_3D" value="{{this.prepago_banorte.certificacion3d}}" />
                    <input type="hidden" name="REFERENCIA3D" value="{{this.prepago_banorte.referencia3d}}" />
                    <input type="hidden" name="CIUDAD" value="{{this.prepago_banorte.ciudad}}" />
                    <input type="hidden" name="PAIS" value="{{this.prepago_banorte.pais}}" />
                    <input type="hidden" name="CORREO" value="{{this.prepago_banorte.correo}}" />
                    <input type="hidden" name="NOMBRE" value="{{this.prepago_banorte.nombre}}" />
                    <input type="hidden" name="APELLIDO" value="{{this.prepago_banorte.apellido}}" />
                    <input type="hidden" name="CODIGO_POSTAL" value="{{this.prepago_banorte.codigo_postal}}" />
                    <input type="hidden" name="ESTADO" value="{{this.prepago_banorte.estado}}" />
                    <input type="hidden" name="CALLE" value="{{this.prepago_banorte.calle}}" />
                    <input type="hidden" name="VERSION_3D" value="{{this.prepago_banorte.version3d}}" />
                    <input type="hidden" name="NUMERO_CELULAR" value="{{this.prepago_banorte.numero_celular}}" />
                    <input type="hidden" name="TIPO_TARJETA" value="{{this.prepago_banorte.tipo_tarjeta}}" />
                </form>

                <!-- Datos del titular -->
                <div class="banorte-seccion-titulo">Datos del titular</div>
                <div class="banorte-grid">
                    <div class="banorte-campo">
                        <label>Correo electrónico</label>
                        <input class="form-control" type="text" placeholder="correo@ejemplo.com"
                            [(ngModel)]="prepago_tarjeta.correo" [ngModelOptions]="{standalone: true}"
                            (change)="CambioCorreo($event)">
                    </div>
                    <div class="banorte-campo">
                        <label>Celular</label>
                        <input class="form-control" type="text" placeholder="10 dígitos"
                            [(ngModel)]="prepago_tarjeta.celular" [ngModelOptions]="{standalone: true}">
                    </div>
                    <div class="banorte-campo">
                        <label>Nombre</label>
                        <input class="form-control" type="text" placeholder="Nombre"
                            [(ngModel)]="prepago_tarjeta.nombre" [ngModelOptions]="{standalone: true}">
                    </div>
                    <div class="banorte-campo">
                        <label>Primer Apellido</label>
                        <input class="form-control" type="text" placeholder="Apellido"
                            [(ngModel)]="prepago_tarjeta.primer_apellido" [ngModelOptions]="{standalone: true}">
                    </div>
                </div>

                <!-- Dirección -->
                <div class="banorte-seccion-titulo">Dirección de facturación</div>
                <div class="banorte-grid">
                    <div class="banorte-campo">
                        <label>Estado</label>
                        <select class="form-control" [(ngModel)]="prepago_tarjeta.estado"
                            [ngModelOptions]="{standalone: true}">
                            <option value="SI">Sinaloa</option>
                            <option value="SO">Sonora</option>
                        </select>
                    </div>
                    <div class="banorte-campo">
                        <label>Ciudad</label>
                        <input class="form-control" type="text" placeholder="Ciudad"
                            [(ngModel)]="prepago_tarjeta.ciudad" [ngModelOptions]="{standalone: true}">
                    </div>
                    <div class="banorte-campo banorte-campo--sm">
                        <label>C.P.</label>
                        <input class="form-control" type="text" placeholder="CP"
                            [(ngModel)]="prepago_tarjeta.codigo_postal" [ngModelOptions]="{standalone: true}">
                    </div>
                    <div class="banorte-campo banorte-campo--full">
                        <label>Calle y número</label>
                        <input class="form-control" type="text" placeholder="Calle" [(ngModel)]="prepago_tarjeta.calle"
                            [ngModelOptions]="{standalone: true}">
                    </div>
                </div>

                <!-- Datos de tarjeta -->
                <div class="banorte-seccion-titulo">Datos de la tarjeta</div>
                <div class="banorte-grid">
                    <div class="banorte-campo banorte-campo--full">
                        <label>Número de Tarjeta</label>
                        <input class="form-control" type="number" id="numero" (change)="CambiaTarjeta($event)"
                            [(ngModel)]="prepago_tarjeta.numero_tarjeta" placeholder="1234 5678 4356 7890"
                            [ngModelOptions]="{standalone: true}">
                    </div>
                    <div class="banorte-campo banorte-campo--sm">
                        <label>MM</label>
                        <input class="form-control" type="text" placeholder="MM" [(ngModel)]="prepago_tarjeta.mes"
                            [ngModelOptions]="{standalone: true}">
                    </div>
                    <div class="banorte-campo banorte-campo--sm">
                        <label>YYYY</label>
                        <input class="form-control" type="text" placeholder="YYYY" [(ngModel)]="prepago_tarjeta.anio"
                            [ngModelOptions]="{standalone: true}">
                    </div>
                    <div class="banorte-campo banorte-campo--sm">
                        <label>CVV / CVC</label>
                        <input class="form-control" type="password" placeholder="•••" [(ngModel)]="prepago_tarjeta.cvv"
                            [ngModelOptions]="{standalone: true}">
                    </div>
                </div>

                <div class="banorte-accion">
                    <button class="btn-pago btn-pago--banorte" (click)="ValidarSubmitBanorte()">
                        <i class="fas fa-lock mr-2"></i>Procesar Pago Seguro
                    </button>
                </div>

            </div>
        </div>
    </div>

</div>